import {TYPELAYER} from './TypeLayerTypes'

export const changeTypeLayer = typeLayer => {
    return {
        type: TYPELAYER,
        load: typeLayer
    }
}

